.root {
  font-weight: 500;
  color: light-dark(var(--mantine-color-primary-7), var(--mantine-color-primary-2));

  & > p {
    font-weight: 500;
  }
}
